import moment from 'moment';
export const API_REQUEST = "http://65.1.6.178:8081";
// export const API_REQUEST = "http://localhost:8081";
// export const API_REQUEST =  "http://172.20.15.63:8081";

export const ORTHANC_SERVER_BASE_URL = "http://172.20.15.136:8042";
// export const ORTHANC_SERVER_BASE_URL ="http://localhost:8042";
export const TICKETING_SYS_BASE_URL = "https://us-central1-ticketing-system-production.cloudfunctions.net/new_app";

export const PERAMAL_INTEGRATOR_BASE_URL = "http://localhost:4040";

export const VOYAGER_INTEGRATOR_BASE_URL = "http://localhost:9098";

export const WSC_SERVICE_ID = "570htwr3H1fhVkW";
export const APP_MESSAGE_BROADCAST_CHANNEL = "radiscan-channel"

export const IMAGE_VIEWERS = {
    INTELEVIEWER: "InteleViewer",
    ORTHANC: "Orthanc"
}

export const modalTypes = {
    ADD: "Add",
    EDIT: "Edit",
};

export const AUTHORIZED_ROLES = ["ADMIN", "GUILDLIBRARIAN", "MRT", "MIS", "TYP", "GROUPADMIN"];

export const INTEGRATOR_AUTHORIZED_ROLES = ["MRT", "MIS"];

export const VISIT_STATES = {
    FR: "FR",
    P: "P",
    SFV: "SFV",
    H: "H",
    V: "V"
}

export const dateFormatList = [
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "DDMMYYYY",
    "YYYY-MM-DD",
    "YYYY-MM-DD hh:mm a"
];

export const paginationSize = 100;
export const pageSizeOptions = ['50', '100', '150', '200'];
export const todaysDate = moment().format("YYYY-MM-DD");
export const past29DaysDate = moment().subtract(29, 'days').format("YYYY-MM-DD");

export const dataTypes = {
    NUMBER: "NUMBER",
    STRING: "STRING",
    DATE: "DATE"
}

export const REFRESH_TOKEN_INTERVAL_IN_MILLISECONDS = 13800 * 1000; // 230 minutes
export const CASE_LIBRARY_ENABLED_HOSTS = ['localhost', '65.1.6.178', '172.20.15.99', 'report.radiscan.com.au'];

export const SPM_EVENTS = {
    spmStopPressed: "spmStopPressed:2",
    spmStopReleased: "spmStopReleased:3",
    spmPlayPressed: "spmPlayPressed:4",
    spmPlayReleased: "spmPlayReleased:5",
    spmRecordPressed: "spmRecordPressed:6",
    spmRecordReleased: "spmRecordReleased:7",
    spmInsertPressed: "spmInsertPressed:8",
    spmInsertReleased: "spmInsertReleased:9",
    spmEOLPressed: "spmEOLPressed:10",
    spmEOLReleased: "spmEOLReleased:11",
    spmFastRewindPressed: "spmFastRewindPressed:12",
    spmFastRewindReleased: "spmFastRewindReleased:13",
    spmFastForwardPressed: "spmFastForwardPressed:14",
    spmFastForwardReleased: "spmFastForwardReleased:15",
    spmPlayStopTogglePressed: "spmPlayStopTogglePressed:20",
    spmPlayStopToggleReleased: "spmPlayStopToggleReleased:21",
};
export const regExp = /^(?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-+`~,<>;:'"\|!@#$%^&*()_./{}])(?!.*[~\`\=[\]\\]).{8,16}/


export const libraries = [
    "lib/GoogleChromeLabs/sdk.js",
    "lib/Augnito/AugnitoCMDs.js?v=3",
    "lib/Augnito/AugnitoCMDStatic.js?v=3",
    "lib/Augnito/AugnitoCMDRegex.js?v=3",
    "lib/Augnito/TextWordToInteger.js?v=3",
    "lib/Augnito/RecordRTC.js",
    "lib/Augnito/AugnitoSDK.js?v=3",
    "lib/jquery.js",
    "lib/MobileMic/GetSetCookie.js",
    "lib/MobileMic/ProcessNotification.js",
    "lib/MobileMic/qrcode.min.js",
    "lib/AugnitoDomParser/AugnitoRange-core.min.js?v=1",
    "lib/AugnitoDomParser/AugnitoRange-classapplier.min.js?v=1",
    "lib/AugnitoDomParser/AugnitoRange-highlighter.min.js?v=1",
    "lib/AugnitoDomParser/AugnitoRange-textcommands.min.js?v=1",
    "lib/AugnitoDomParser/AugnitoRange-textrange.min.js?v=1",
    "lib/AugnitoDomParser/AugnitoRange-util.min.js?v=1",
    "lib/AugnitoDomParser/AugnitoRangeSaveRestore.min.js?v=1",
    "lib/Undo.js",
    "lib/PhilipsMicHandler.js?v=3",
    // "lib/jquery-ui/jquery-ui.js?v=1",
    "lib/CommonEditorProcess.js?v=1",
    "lib/GenericEditorProcessV2.js?v=2",
    "lib/CKEditorProcess.js"
];

const getCkeditorThemeColors = () => {
    const isDarkTheme = document.body.classList.contains("dark-theme");

    return isDarkTheme
        ? { background: "#142B37", color: "#ffffff" }
        : { background: "#ffffff", color: "#000000" };
};

const applyCkeditorThemeColors = (editor) => {
    if (!editor || !editor.document) {
        return;
    }

    const colors = getCkeditorThemeColors();
    const body = editor.document.getBody();
    const documentElement = editor.document.getDocumentElement();

    if (body) {
        body.setStyle("background-color", colors.background);
        body.setStyle("color", colors.color);
    }

    if (documentElement) {
        documentElement.setStyle("background-color", colors.background);
    }
};

export const CKEDITOR4_CONFIG = {
    height: 200,
    versionCheck: false,
    startupFocus: true,
    bodyClass: "radiscan-ckeditor-content",
    contentsCss: [
      "data:text/css;charset=utf-8," + encodeURIComponent(
        "html, body.radiscan-ckeditor-content, body.radiscan-ckeditor-content.cke_editable { min-height: 100%; } body.radiscan-ckeditor-content * { color: inherit !important; }"
      )
    ],
    on: {
      instanceReady: function (event) {
        const editor = event.editor;
        applyCkeditorThemeColors(editor);

        if (window.MutationObserver) {
          const observer = new MutationObserver(function () {
            applyCkeditorThemeColors(editor);
          });

          observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"]
          });

          editor.on("destroy", function () {
            observer.disconnect();
          });
        }
      }
    },
  
    // Better to disable browser spellcheck so it does not clash with SCAYT
    disableNativeSpellChecker: true,
  
    // SCAYT Cloud activation
    scayt_customerId: WSC_SERVICE_ID,
  
    // Auto start spell check
    scayt_autoStartup: true,
  
    // Auto start grammar check
    grayt_autoStartup: true,
  
    // Default language
    scayt_sLang: "en_GB",
  
    extraPlugins:
      typeof window !== "undefined" &&
      window.CKEDITOR &&
      window.CKEDITOR.plugins &&
      window.CKEDITOR.plugins.registered &&
      window.CKEDITOR.plugins.registered.compacttoolbar
        ? "compacttoolbar,tableresize"
        : "tableresize",

    fontSize_sizes: "8/8pt;9/9pt;10/10pt;11/11pt;12/12pt;14/14pt;16/16pt;18/18pt;20/20pt;22/22pt;24/24pt;26/26pt;28/28pt;36/36pt;48/48pt",

    removeButtons:
      typeof window !== "undefined" &&
      window.CKEDITOR &&
      window.CKEDITOR.plugins &&
      window.CKEDITOR.plugins.registered &&
      window.CKEDITOR.plugins.registered.compacttoolbar
        ? "Maximize,Font,FontSize,Image,Cut,Copy,Paste,PasteText,PasteFromWord,Styles,Blockquote,Subscript,Superscript,NumberedList,BulletedList,Table,HorizontalRule,SpecialChar"
        : "Maximize,Font,FontSize,Image,Cut,Copy,Paste,PasteText,PasteFromWord,Styles,Blockquote",

    toolbarGroups: [
      {
        name: "clipboard",
        groups: ["clipboard", "undo"]
      },
      {
        name: "editing",
        groups: ["find", "selection", "spellchecker", "editing"]
      },
      {
        name: "basicstyles",
        groups: ["basicstyles", "cleanup"]
      },
      {
        name: "paragraph",
        groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"]
      },
      {
        name: "insert"
      },
      {
        name: "styles"
      },
      {
        name: "colors"
      },
      {
        name: "tools"
      }
    ]
  };

export const priorities = [
    {
        name: 'NONE',
        value: 'N'
    },
    {
        name: 'EMERGENCY',
        value: 'J'
    },
    {
        name: 'URGENT',
        value: 'A'
    },
    {
        name: '3D',
        value: 'C'
    },
    {
        name: '3D URGENT',
        value: 'B'
    },
    {
        name: 'PRIORITY1',
        value: 'F'
    },
    {
        name: 'PRIORITY2',
        value: 'G'
    },
    {
        name: 'PRIORITY3',
        value: 'H'
    }
]

export const DEFAULT_CONFIGURATIONS_TYPES = {
    default_theme: "string",
    default_ris_id: "int",
    default_mip_id: "int",
    deadman_switch: "boolean",
    show_my_cases_only: "false",
    default_editor_theme: "string",
    exit_visit_no_confirm: "boolean",
    auto_launch_iv_sfv: "boolean"
}